import {
    Configuration,
    EventType,
    IPublicClientApplication,
    PublicClientApplication,
} from '@azure/msal-browser';

const POST_LOGOUT_REDIRECT_URI = '/';
const MICROSOFT_DOMAINS = [
    '.microsoft.com',
    '.login.microsoftonline.com',
    '.live.com',
];
class MicrosoftAuthService {
    msalInstance: IPublicClientApplication = null;
    initialize(msalConfig: Configuration) {
        this.msalInstance = new PublicClientApplication(msalConfig);

        // Default to using the first account if no account is active on page load
        if (
            !this.msalInstance.getActiveAccount() &&
            this.msalInstance.getAllAccounts().length > 0
        ) {
            // Account selection logic is app dependent. Adjust as needed for different use cases.
            this.msalInstance.setActiveAccount(
                this.msalInstance.getAllAccounts()[0],
            );
        }

        // Optional - This will update account state if a user signs in from another tab or window
        // this.msalInstance.enableAccountStorageEvents();

        // Listen for sign-in event and set active account
        this.msalInstance.addEventCallback((event: any) => {
            if (
                event.eventType === EventType.LOGIN_SUCCESS &&
                event.payload.account
            ) {
                const account = event.payload.account;
                this.msalInstance.setActiveAccount(account);
            }
        });

        return this.msalInstance;
    }

    private deleteCookies() {
        const cookies = document.cookie.split('; ');
        cookies.forEach(cookie => {
            const eqPos = cookie.indexOf('=');
            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            if (name.includes('login.microsoft')) {
                document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.microsoftonline.com`;
            }
        });
    }

    async silentLogout() {
        if (this.msalInstance) {
            const activeAccount = this.msalInstance.getActiveAccount();
            if (activeAccount && activeAccount.idTokenClaims) {
                await this.msalInstance
                    .logout({
                        account: activeAccount,
                        postLogoutRedirectUri: POST_LOGOUT_REDIRECT_URI,
                        logoutHint: activeAccount.idTokenClaims.login_hint,
                        onRedirectNavigate: url => {
                            return false;
                        },
                    })
                    .catch(console.error);
                localStorage.removeItem('msal.idtoken');
                localStorage.removeItem('msal.accesstoken');
                this.msalInstance.setActiveAccount(null);
            }
            this.deleteCookies();
            // sessionStorage.clear();
        }
    }

    async logout() {
        await this.msalInstance.logout();
    }
}

export const microsoftAuthService = new MicrosoftAuthService();
